// src/app/pages/expediente/expediente-digital/sections/paraclinicos/paraclinicos-page/components/analizador-laboratorio/analizador-laboratorio.component.ts

import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LaboratorioParserService } from '../../../../../../../../services/laboratorio/laboratorio-parser.service';
import { LaboratorioService } from '../../../../../../../../services/laboratorio/laboratorio.service';
import { ResultadoExtraido } from '../../../../../../../../interfaces/laboratorio/resultado-laboratorio.interface';
import { ParametroLaboratorio } from '../../../../../../../../interfaces/laboratorio/parametro-laboratorio.interface';

@Component({
  selector: 'app-analizador-laboratorio',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './analizador-laboratorio.component.html',
  styleUrls: ['./analizador-laboratorio.component.scss'],
})
export class AnalizadorLaboratorioComponent {
  @Input() archivo!: File;
  @Input() categoria!: string;
  @Input() appointmentId!: number;
  @Input() paraclinicoUuid!: string;

  @Output() resultadosExtraidos = new EventEmitter<ResultadoExtraido[]>();
  @Output() cerrado = new EventEmitter<void>();

  // Estados
  isOpen = false;
  estado: 'extrayendo' | 'parseando' | 'mostrando' | 'error' = 'extrayendo';
  progreso = 0;
  mensajeEstado = '';
  errorMensaje = '';

  // Resultados
  resultados: ResultadoExtraido[] = [];
  parametrosCatalogo: ParametroLaboratorio[] = [];

  constructor(private parserService: LaboratorioParserService, private laboratorioService: LaboratorioService) {}

  /**
   * Abrir modal e iniciar análisis
   */
  async open() {
    this.isOpen = true;
    this.estado = 'extrayendo';
    this.progreso = 0;
    this.resultados = [];

    try {
      // 1. Cargar catálogo de parámetros
      this.mensajeEstado = 'Cargando catálogo de parámetros...';
      this.parametrosCatalogo = await this.laboratorioService.getParametros(this.categoria);
      this.parserService.setParametrosCatalogo(this.parametrosCatalogo);
      this.progreso = 10;

      // 2. Extraer texto del PDF
      this.mensajeEstado = 'Extrayendo texto del PDF...';
      const texto = await this.parserService.extractTextFromPDF(this.archivo);
      this.progreso = 50;

      // 3. Parsear parámetros
      this.estado = 'parseando';
      this.mensajeEstado = 'Identificando parámetros...';
      this.resultados = this.parserService.matchParameters(texto, this.categoria);
      this.progreso = 90;

      // 4. Mostrar resultados
      this.estado = 'mostrando';
      this.progreso = 100;
      this.mensajeEstado = `${this.resultados.length} parámetros encontrados`;

      // Emitir resultados
      this.resultadosExtraidos.emit(this.resultados);
    } catch (error: any) {
      console.error('Error en análisis:', error);
      this.estado = 'error';
      this.errorMensaje = error.message || 'Error analizando el PDF';
    }
  }

  /**
   * Cerrar modal
   */
  close() {
    this.isOpen = false;
    this.cerrado.emit();
  }

  /**
   * Reintentar análisis
   */
  reintentar() {
    this.open();
  }

  /**
   * Calcular confianza promedio
   */
  calcularConfianzaPromedio(): number {
    if (this.resultados.length === 0) return 0;

    const suma = this.resultados.reduce((acc, r) => acc + (r.confianza || 0), 0);
    return Math.round((suma / this.resultados.length) * 100);
  }

  /**
   * Contar resultados fuera de rango
   */
  getCountFueraRango(): number {
    return this.resultados.filter((r) => r.fueraRango === true).length;
  }
}
